<template>
  <div id="content-container">
    <div class="text-center" style="margin-top: 100px; font-size: 30px">
      欢迎回来。
    </div>
    <!-- <el-row :gutter="14" class="mt-20">
      <el-col :span="14">
        <div class="home-search">
          <el-select
            v-model="selectQueryResult"
            class="hookiOS"
            filterable
            remote
            reserve-keyword
            :placeholder="placeholder"
            value-key="id"
            :loading="searchLoading"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-option-group
              v-for="group in searchResults"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.id"
                :label="item.title"
                :value="item"
              >
                <p class="flex-row-between">
                  <span>{{ item.title }}</span>
                  <span>{{ item.subtitle }}</span>
                </p>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="actions">
          <h4>快捷操作</h4>
          <div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              v-permission="Auth.customerNew"
              >新客户</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              v-permission="Auth.orderNew"
              >新报价</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              v-permission="Auth.customerFollowUpNew"
              >拜访记录</el-button
            >
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="14">
      <el-col :span="14">
        <div class="panel mb-20">
          <div class="header flex-row-between">
            <h2>审批消息</h2>
          </div>
          <ul v-if="approveEvents.length > 0" class="messages">
            <li v-for="item in approveEvents">
              <router-link class="flex-row-between" :to="item.link">
                <span class="content">
                  <span style="flex: 1"
                    >[{{ approveEventTypeMap[item.category] }}]
                    {{ item.content }}</span
                  >
                </span>
                <span class="date">{{ formatTime(item.created_at) }}</span>
              </router-link>
            </li>
          </ul>
          <div v-else class="text-info-12">暂无审批消息</div>
        </div>

        <div class="panel">
          <div class="header flex-row-between">
            <h2>最新消息</h2>
            <router-link to="/dashboard/messages" class="text-primary font-12"
              >全部消息</router-link
            >
          </div>
          <ul v-if="messages.length > 0" class="messages">
            <li v-for="item in messages">
              <router-link class="flex-row-between" :to="item.link">
                <span class="content">
                  <i :class="{ unread: item.status == 1 }"></i>
                  <span style="flex: 1">{{ item.content }}</span>
                </span>
                <span class="date">{{ formatTime(item.created_at) }}</span>
              </router-link>
            </li>
          </ul>
          <div v-else class="text-info-12">暂无新消息</div>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="panel">
          <div class="header">
            <h2>最近操作客户</h2>
          </div>
        </div>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import { menuGroups } from '@/config/navs'

export default {
  data() {
    return {
      messages: [],
      todos: [],
      approveEvents: [],
      searchLoading: false,
      searchResultVisible: false,
      searchResults: [],
      selectQueryResult: null,
    }
  },
  computed: {
    placeholder() {
      let arr = []

      arr.push('客户')
      arr.push('订单号')
      arr.push('报价单号')

      let p = ''
      if (arr.length > 0) {
        p = '搜索' + arr.join('、')
      }

      return p
    },
  },
  created() {
    outloop: for (let index = 0; index < menuGroups.length; index++) {
      const group = menuGroups[index]
      if (this.hasAuth(group.authName)) {
        for (let cindex = 0; cindex < group.children.length; cindex++) {
          const child = group.children[cindex]
          if (this.hasAuth(child.authName)) {
            this.$router.push(child.path)
            break outloop
          }
        }
        break
      }
    }
  },
  methods: {},
}
</script>

<style scoped>
.current-customer span {
  cursor: pointer;
  margin-right: 10px;
}

.messages li {
  padding: 10px 0;
  color: #555;
}

.messages li .date {
  color: #999;
  width: 100px;
  text-align: right;
}

.messages li .content {
  flex: 1;
  display: flex;
  align-items: center;
}

.messages li .content i {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 4px;
  margin-top: -2px;
}

.messages li .content i.unread {
  background-color: green;
}

input.el-input__inner {
  background-color: rgba(121, 138, 185, 0.07) !important;
}

.data-list {
  margin-top: 20px;
}
.data-list li span {
  display: block;
  text-align: center;
}
.data-list li span.value {
  font-size: 24px;
  font-weight: 500;
}
.data-list li span.title {
  color: #999;
}
.data-item {
  margin-top: 10px;
  color: #888;
  margin-bottom: 3px;
  min-width: 30%;
}
.data-item .value {
  color: #047bf8;
}
.target-item {
  margin: 20px 0 10px;
}
.data-item .target {
  color: #047bf8;
  font-size: 20px;
}
.actions {
  height: 80px;
}
.actions h4 {
  font-size: 14px;
  margin-bottom: 10px;
}
.el-select--mini {
  width: 120px !important;
}

.messages li a {
  color: #333;
}
.active-customers li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
  margin-top: 12px;
}
.active-customers {
  margin-top: 20px;
}
.active-customers li:last-child {
  border-bottom: 0 none;
}
.active-customers li .content {
  flex: 1;
}
.active-customers li .type {
  width: 80px;
  text-align: right;
  color: gray;
  line-height: 1.2em;
}
</style>